import React from 'react';
import { Calendar } from 'lucide-react';
import { useStore } from '../store';

export default function BookButton() {
  const isModelAnimationComplete = useStore((state) => state.isModelAnimationComplete);

  const handleBookingClick = () => {
    window.open('https://kitcocloset.dayschedule.com/private-outfitting', '_blank');
  };

  return (
    <div>
      {isModelAnimationComplete && (
        <div className="fixed z-50 bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 animate-fade-in">
          <button
            onClick={handleBookingClick}
            className="relative group bg-pink-200 text-pink-400 px-8 py-2.5 rounded-lg 
              hover:bg-pink-400 hover:text-pink-200 transition-all duration-300 min-w-[250px]
              flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
          >
            <Calendar className="w-5 h-5" />
            Book Private Session
          </button>
        </div>
      )}
    </div>
  );
}